<template>
  <div>
    <a-modal v-model="visible" width="560px" title="编辑安装包" ok-text="确认" cancel-text="取消" :ok-button-props="{ props: { loading: loading } }" @ok="submit" @cancel="close('cancel')">
      <a-form-model ref="modalForm" :model="modalForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="标签">
          <a-select v-model="modalForm.tags" show-search mode="multiple" placeholder="标签">
            <a-select-option v-for="(item, tag_id) in packageTags" :key="tag_id" :value="item.value">{{ item.label }} </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { packageModify } from '@/api/tools/package';
import { packageTags } from '@/utils/dictionary';
export default {
  name: 'PackageModal',
  props: {
    packageId: {
      type: [Number, String]
    },
    tags: {
      type: [String, Array],
      default: []
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      packageTags,
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      modalForm: {
        tags: this.tags
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.modalForm.tags = this.tags;
      }
    }
  },
  methods: {
    close() {
      this.loading = false;
      this.visible = false;
      this.$emit('close');
    },

    submit() {
      this.loading = true;
      packageModify({ package_id: this.packageId, ...this.modalForm })
        .then(() => {
          this.$message.success('修改成功');
          this.close();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
